import React, { useState } from "react";
import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import { formatModifyDate } from "../../../components/Common/CommonLogic";

const AirSearchDetails = ({ showHistory, searchData, trackingEvents }) => {
    // State for active tab (history or route)
    const [activeTab, setActiveTab] = useState("history");
    
    // Format date helper function
    const formatDate = (dateString) => {
        if (!dateString) return "";
        return formatModifyDate(dateString);
    };
    
    // Toggle between tabs
    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <>
            <Card className="shadow rounded-4 p-3 mb-4">
                <CardBody>
                    {/* Header with tracking number and status */}
                    <Row className="mb-3">
                        <Col md="6">
                            <h5 className="fw-bold">{searchData?.trackingNumber || "618-39310235"}</h5>
                            <div className="d-flex align-items-center">
                                <span className="me-2">{searchData?.pieces || "83"} pieces / {searchData?.weight || "1013"} kg</span>
                                <span className="badge bg-success text-white px-2 py-1">DELIVERED</span>
                            </div>
                        </Col>
                        <Col md="6" className="text-end">
                            <Button color="primary" size="sm" onClick={showHistory}>View History</Button>
                        </Col>
                    </Row>

                    {/* Route visualization */}
                    <Row className="mb-4">
                        <Col md="12">
                            <div className="position-relative">
                                <div className="d-flex justify-content-between mb-2">
                                    <div>
                                        <h6 className="fw-bold mb-0">{searchData?.origin?.code || "PEK"} ({searchData?.origin?.city || "Beijing"})</h6>
                                    </div>
                                    <div className="text-end">
                                        <h6 className="fw-bold mb-0">{searchData?.destination?.code || "MXP"} ({searchData?.destination?.city || "Milan"})</h6>
                                    </div>
                                </div>
                                
                                {/* Progress line */}
                                <div className="position-relative" style={{ height: "4px" }}>
                                    <div className="bg-danger w-100" style={{ height: "4px" }}></div>
                                    
                                    {/* Origin dot */}
                                    <div className="position-absolute" style={{ left: "0", top: "-6px" }}>
                                        <div className="rounded-circle bg-danger" style={{ width: "16px", height: "16px" }}></div>
                                    </div>
                                    
                                    {/* Destination dot */}
                                    <div className="position-absolute" style={{ right: "0", top: "-6px" }}>
                                        <div className="rounded-circle bg-danger" style={{ width: "16px", height: "16px" }}></div>
                                    </div>
                                </div>
                                
                                {/* Departure and arrival times */}
                                <div className="d-flex justify-content-between mt-2">
                                    <div>
                                        <small className="text-muted">ATD {formatDate(searchData?.origin?.departureDate) || "13 Jan 2025 17:00"}</small>
                                    </div>
                                    <div className="text-end">
                                        <small className="text-muted">ATA {formatDate(searchData?.destination?.arrivalDate) || "15 Jan 2025 08:50"}</small>
                                    </div>
                                </div>
                                
                                {/* Carrier */}
                                <div className="text-center mt-2">
                                    <small className="text-muted">{searchData?.carrier || "Singapore Airlines"}</small>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Tabs for History/Route */}
                    <Row className="mb-3">
                        <Col>
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                    <a 
                                        className={`nav-link ${activeTab === "history" ? "active" : ""}`} 
                                        href="#" 
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toggleTab("history");
                                        }}
                                    >
                                        History
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        className={`nav-link ${activeTab === "route" ? "active" : ""}`} 
                                        href="#" 
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toggleTab("route");
                                        }}
                                    >
                                        Route
                                    </a>
                                </li>
                            </ul>
                        </Col>
                    </Row>

                    {/* Tab Content */}
                    {activeTab === "history" && (
                        /* Timeline for History tab */
                        <div style={{
                        position: "relative",
                        paddingLeft: "20px"
                        }}>
                    {/* Timeline vertical line */}
                    <div style={{
                        position: "absolute",
                        left: 0,
                        top: 0,
                        height: "100%",
                        width: "2px",
                        backgroundColor: "#e0e0e0"
                    }}></div>
                        {/* Origin */}
                        <div style={{ position: "relative", paddingBottom: "20px" }}>
                            <div style={{
                                position: "absolute",
                                left: "-24px",
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor: "#dc3545",
                                border: "2px solid #fff",
                                boxShadow: "0 0 0 2px #dc3545"
                            }}></div>
                            <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
                                <h6 className="mb-0 fw-bold">PEK (Beijing)</h6>
                                <div style={{ paddingLeft: "0", marginTop: "8px" }}>
                                    <div className="mb-2">
                                        <div>Freight on hand, 83 pcs / 1013 kg</div>
                                        <small className="text-muted">12 Jan 2025 16:46</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Received from shipper, 83 pcs / 1013 kg</div>
                                        <small className="text-muted">12 Jan 2025 20:06</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Departed, 83 pcs / 1013 kg, flight №: SQ 0807</div>
                                        <small className="text-muted">13 Jan 2025 17:00</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Transit */}
                        <div style={{ position: "relative", paddingBottom: "20px" }}>
                            <div style={{
                                position: "absolute",
                                left: "-24px",
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor: "#dc3545",
                                border: "2px solid #fff",
                                boxShadow: "0 0 0 2px #dc3545"
                            }}></div>
                            <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
                                <h6 className="mb-0 fw-bold">SIN (Singapore)</h6>
                                <div style={{ paddingLeft: "0", marginTop: "8px" }}>
                                    <div className="mb-2">
                                        <div>Arrived, 83 pcs / 1013 kg, flight №: SQ 0807</div>
                                        <small className="text-muted">13 Jan 2025 23:15</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Received from flight, 83 pcs / 1013 kg, flight №: SQ 0807</div>
                                        <small className="text-muted">14 Jan 2025 02:46</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Departed, 83 pcs / 1013 kg, flight №: SQ 0378</div>
                                        <small className="text-muted">15 Jan 2025 02:38</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Destination */}
                        <div style={{ position: "relative", paddingBottom: "20px" }}>
                            <div style={{
                                position: "absolute",
                                left: "-24px",
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor: "#dc3545",
                                border: "2px solid #fff",
                                boxShadow: "0 0 0 2px #dc3545"
                            }}></div>
                            <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
                                <h6 className="mb-0 fw-bold">MXP (Milan)</h6>
                                <div style={{ paddingLeft: "0", marginTop: "8px" }}>
                                    <div className="mb-2">
                                        <div>Arrived, 83 pcs / 1013 kg, flight №: SQ 0378</div>
                                        <small className="text-muted">15 Jan 2025 08:50</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Received from flight, 83 pcs / 1013 kg, flight №: SQ 0378</div>
                                        <small className="text-muted">15 Jan 2025 09:51</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Notified, 83 pcs / 1013 kg</div>
                                        <small className="text-muted">15 Jan 2025 10:52</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Docs delivered to the consignee, 83 pcs / 1013 kg</div>
                                        <small className="text-muted">15 Jan 2025 12:12</small>
                                    </div>
                                    <div className="mb-2">
                                        <div>Delivered, 83 pcs / 1013 kg</div>
                                        <small className="text-muted">20 Jan 2025 16:05</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {activeTab === "route" && (
                        /* Route tab content */
                        <div className="route-content mt-3">
                            {/* First Flight */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between mb-2">
                                    <div>
                                        <h6 className="text-muted mb-1">Flight number</h6>
                                        <div className="fw-bold">SQ 0807</div>
                                    </div>
                                    <div>
                                        <h6 className="text-muted mb-1">Transport type</h6>
                                        <div className="fw-bold">PLANE</div>
                                    </div>
                                </div>
                                
                                <div className="d-flex justify-content-between mb-2">
                                    <div>
                                        <h6 className="text-muted mb-1">Origin</h6>
                                        <div className="fw-bold">Beijing Capital International Airport</div>
                                    </div>
                                    <div>
                                        <h6 className="text-muted mb-1">Destination</h6>
                                        <div className="fw-bold">Singapore Changi International Airport</div>
                                    </div>
                                </div>
                                
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <h6 className="text-muted mb-1">ATD</h6>
                                        <div className="fw-bold">13 Jan 2025 17:00</div>
                                    </div>
                                    <div>
                                        <h6 className="text-muted mb-1">ATA</h6>
                                        <div className="fw-bold">13 Jan 2025 23:15</div>
                                    </div>
                                </div>
                            </div>
                            
                            <hr className="my-4" />
                            
                            {/* Second Flight */}
                            <div>
                                <div className="d-flex justify-content-between mb-2">
                                    <div>
                                        <h6 className="text-muted mb-1">Flight number</h6>
                                        <div className="fw-bold">SQ 0378</div>
                                    </div>
                                    <div>
                                        <h6 className="text-muted mb-1">Transport type</h6>
                                        <div className="fw-bold">PLANE</div>
                                    </div>
                                </div>
                                
                                <div className="d-flex justify-content-between mb-2">
                                    <div>
                                        <h6 className="text-muted mb-1">Origin</h6>
                                        <div className="fw-bold">Singapore Changi International Airport</div>
                                    </div>
                                    <div>
                                        <h6 className="text-muted mb-1">Destination</h6>
                                        <div className="fw-bold">Malpensa International Airport</div>
                                    </div>
                                </div>
                                
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <h6 className="text-muted mb-1">ATD</h6>
                                        <div className="fw-bold">15 Jan 2025 02:38</div>
                                    </div>
                                    <div>
                                        <h6 className="text-muted mb-1">ATA</h6>
                                        <div className="fw-bold">15 Jan 2025 08:50</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </CardBody>
            </Card>

            {/* Timeline styles are applied using inline styles */}
        </>
    );
};

export default AirSearchDetails;